/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/kidney', children: 'kidney' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/KidneyLink.js